import { render, staticRenderFns } from "./others_table.vue?vue&type=template&id=7a062302&lang=pug&"
import script from "./others_table.vue?vue&type=script&lang=js&"
export * from "./others_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports